import { FC } from 'react';
import { QuestionnaireDocumentChecklistSectionProps } from './QuestionnaireDocumentChecklistSection.types';
import { DocumentChecklistBlock } from './components/DocumentChecklistBlock';

export const QuestionnaireDocumentChecklistSection: FC<
  QuestionnaireDocumentChecklistSectionProps
> = ({ isLocked, mode, isReviewSection, questionnaire, section }) => {
  return (
    <DocumentChecklistBlock
      isReviewSection={isReviewSection}
      isLocked={isLocked}
      mode={mode}
      questionnaire={questionnaire}
      section={section}
      title="Documents"
    />
  );
};
